module.exports = __webpack_public_path__ + "static/media/arrow-order-asc.b51e8e56.svg";